import { render, staticRenderFns } from "./EventCellCard.vue?vue&type=template&id=331d134c&scoped=true&"
import script from "./EventCellCard.vue?vue&type=script&lang=js&"
export * from "./EventCellCard.vue?vue&type=script&lang=js&"
import style0 from "./EventCellCard.vue?vue&type=style&index=0&id=331d134c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d134c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
